import * as React from 'react'

import { VehicleModel } from '@/app/models'
import { useVehicles } from '@/modules/shared/context/vehicles/VehiclesContext'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { FaIcon, faTruckSolid } from '@/lib/fa'
import { RouteComponentProps, withRouter } from '@/app/navigation/withRouter'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { pathForSelectedVehicle } from '../../../utils/resolveVehiclePath'

interface VehicleRowProps extends RouteComponentProps {
  vehicle: VehicleModel
}

const VehicleRow: React.FC<VehicleRowProps> = ({ vehicle }) => {
  const isActive = vehicle?.isActive
  const { setSelectedVehicleId } = useVehicles()
  const navigate = useNavigate()
  const location = useLocation()
  const { companyId } = useParams<{ companyId: string }>()

  const handleClick = () => {
    if (!companyId) return
    navigate(pathForSelectedVehicle(location.pathname, companyId, vehicle.id))
    setSelectedVehicleId(vehicle.id)
  }
 

  const [isHovered, setIsHovered] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  return (
    <tr
      className={`notches-border--right tw-w-fit tw-cursor-pointer tw-border-b tw-bg-white hover:tw-bg-primary/10 ${!isActive ? 'tw-opacity-30' : ''}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableTextRow
        size="small"
        icon={<FaIcon icon={faTruckSolid} className="tw-text-content-base" />}
      >
        {vehicle.registrationNumber}
      </TableTextRow>
      <TableTextRow size="small">{vehicle.vinNumber}</TableTextRow>
      <TableTextRow size="small">{vehicle.make}</TableTextRow>
      <TableTextRow size="small">{vehicle.model}</TableTextRow>
    </tr>
  )
}

export default withRouter(VehicleRow)
